import AbstractSpecification from "../specification/AbstractSpecification.js";

/**
 * `AccountNumberListSpecification` is a concrete implementation
 * of `AbstractSpecification` representing a server side
 * specification of a list of account numbers.
 *
 * @param {string[]} spec.accountNumbers - list of account numbers
 */
export default class AccountNumberListSpecification extends AbstractSpecification {
	constructor({ accountNumbers } = {}) {
		super(...arguments);
		this._accountNumbers = accountNumbers;
	}

	getAccountNumbers() {
		return this._accountNumbers;
	}

	accept(visitor, additionalInformation) {
		return visitor.visitAccountNumberListSpecification(
			this,
			additionalInformation,
		);
	}

	isLeaf() {
		return true;
	}

	_serializedProperties() {
		const schema = super._serializedProperties();

		schema.accountNumbers = this._accountNumbers;

		return schema;
	}

	static getType() {
		return "AccountNumberListSpecification";
	}
}
